import classNames from 'classnames';
import Avatar from '../../Atoms/Avatar';
import Text from '../../Atoms/Text';
import { Props as ImgProps } from '../../Atoms/Image';

interface Props {
  img: ImgProps;
  text: string;
  className?: string;
  textColor?:
    | 'blue'
    | 'blue-dark'
    | 'yellow'
    | 'indigo'
    | 'gray'
    | 'white';
}

function UserInfo({
  img,
  text,
  className,
  textColor = 'blue'
}: Props) {
  return (
    <div
      className={classNames([
        'flex items-center gap-2.5',
        className
      ])}
    >
      <Avatar img={img} small />
      <Text
        as="span"
        size="sm"
        weight={600}
        color={textColor}
      >
        {text}
      </Text>
    </div>
  );
}

export default UserInfo;
